import React from "react";
import { Box, Checkbox, Divider, Flex, useColorMode } from "@chakra-ui/react";
import utils from "../utils";
import { ItemNode } from "./ItemNode";

export const TaskNode = (props) => {
  const { colorMode } = useColorMode();
  const darkThemeEnabled = colorMode !== "light";

  function isChecked() {
    return props.completedSteps.includes(props.id.toString());
  }

  const tasksSegment =
    props.tasks.length > 0
      ? props.tasks.map((task, index) => (
          <TaskNode
            index={index}
            incrementType={props.incrementType === "1" ? "A" : "1"}
            key={task.id}
            id={task.id}
            description={task.description}
            progressPoints={task.progressPoints}
            checkable={task.checkable}
            icon={task.icon}
            items={task.items}
            tasks={task.tasks}
            nestDepth={props.nestDepth + 1}
            completedSteps={props.completedSteps}
            onTaskCheckChange={props.onTaskCheckChange}
            instructionKey={props.instructionKey}
          />
        ))
      : "";

  const itemsSegment =
    props.items.length > 0
      ? props.items.map((item) => (
          <ItemNode
            key={item.id}
            item={item}
            instructionKey={props.instructionKey}
          />
        ))
      : "";

  return (
    <Box ml={props.nestDepth > 0 ? 26 : 0} pt={2}>
      {props.nestDepth === 0 && props.emphasizeRootTasks ? <Divider /> : ""}
      <Flex>
        <Flex>
          <Box w="26px">
            {utils.getIncrementDisplay(props.index, props.incrementType)}
          </Box>
        </Flex>
        <Flex>
          {props.checkable ? (
            <Box w="26px">
              <Checkbox
                {
                  // Conditionally override the border color for the light theme to be darker.
                  ...(!darkThemeEnabled
                    ? { borderColor: "rgb(26, 32, 44)" }
                    : {})
                }
                size="lg"
                pt="4px"
                colorScheme="green"
                aria-labelledby={props.id + "-text"}
                isChecked={isChecked()}
                onChange={(e) =>
                  props.onTaskCheckChange(props.id.toString(), e.target.checked)
                }
              ></Checkbox>
            </Box>
          ) : (
            ""
          )}
        </Flex>
        <Flex w="100%">
          <Box
            backgroundColor={
              isChecked() ? (darkThemeEnabled ? "gray.600" : "gray.200") : ""
            }
            rounded="md"
            pr={1}
            pl={1}
            pb={1}
            w="100%"
          >
            <Box
              id={props.id + "-text"}
              dangerouslySetInnerHTML={{
                __html: utils.formatDisplayText(props.description),
              }}
            ></Box>
            <Box>{itemsSegment}</Box>
          </Box>
        </Flex>
      </Flex>

      <Box>{tasksSegment}</Box>
    </Box>
  );
};
